import deft from './default';
import dark from './dark';

export default [
	deft,
	dark,
]
